import _ from 'lodash'
import { combineReducers } from 'redux'
import * as Activity from './activity'
import * as Common from './common'
import * as Entities from './entities'
import * as Location from './location'
import * as Planner from './planner'

export interface IState {
    entities: Entities.TEntitiesState
    common: Common.TCommonState
    activity: Activity.TActivityState
    location: Location.TLocationState
    planner: Planner.TPlannerState
}

export default combineReducers<IState>({
    entities: Entities.entitiesReducer,
    common: Common.commonReducer,
    activity: Activity.activityReducer,
    location: Location.locationReducer,
    planner: Planner.plannerReducer,
})

/* entity selectors */
export function getEntityArray<K extends keyof Entities.TEntitiesState>(
    state: IState,
    entity: K
): Entities.TEntitiesState[K] {
    return Entities.getEntityArray(state.entities, entity)
}

export function getEntityById<K extends keyof Entities.TEntitiesState>(
    state: IState,
    entity: K,
    id: number
): Entities.TEntitiesState[K][0] {
    const result = Entities.getEntityById(state.entities, entity, id)
    if (result == null) {
        /* eslint-disable-next-line no-console */
        console.log('failed to find entity', entity, id, state.entities)
    }
    return result
}

/* activity selectors */
export const getReportEvent = (state: IState) => Activity.getReportEvent(state.activity)
export const getReportEventId = (state: IState) => Activity.getReportEventId(state.activity)
export const getReportEventCampaignId = (state: IState) => Activity.getReportEventCampaignId(state.activity)

export const getReportEventCampaign = (state: IState) => {
    const campaignId = getReportEventCampaignId(state)
    return campaignId ? getEntityById(state, 'campaigns', campaignId) : null
}

export function getCoordinates(state: IState) {
    return Common.getCoordinates(state.common)
}
